var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 14,
    viewBox: "0 0 15 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.49994 5.41831V12.5433M7.49994 5.41831L9.87494 7.79331M7.49994 5.41831L5.12494 7.79331M11.8541 9.37665C13.0566 9.37665 13.8333 8.40211 13.8333 7.19956C13.8332 6.72347 13.6771 6.26051 13.3889 5.8816C13.1006 5.50269 12.6961 5.22872 12.2373 5.10165C12.1667 4.21376 11.7987 3.37563 11.1928 2.72276C10.5869 2.0699 9.77857 1.64045 8.89842 1.50386C8.01827 1.36727 7.11777 1.53151 6.34252 1.97004C5.56726 2.40857 4.96257 3.09575 4.62619 3.92048C3.91799 3.72416 3.1608 3.81722 2.52121 4.17918C1.88162 4.54115 1.41201 5.14236 1.21569 5.85056C1.01938 6.55877 1.11243 7.31595 1.4744 7.95555C1.83636 8.59514 2.43757 9.06475 3.14577 9.26106",
    stroke: "white",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.48fc5e053fa0e06422c41bf7d8ad7937.svg";
export { ForwardRef as ReactComponent };